function waiseRevisionResource(type, payload = {}) {
  const id = payload.id ?? payload.inventory_id;
  const [family, action] = String(type).split('.');
  const tables = {
    warehouse: 'warehouses',
    supplier: 'suppliers',
    'stock-item': 'stock_items',
    'purchase-order': 'purchase_orders',
    recipe: 'recipes',
    inventory: 'inventories',
    loss: 'waise_loss_declarations'
  };
  if (Object.prototype.hasOwnProperty.call(tables, family) && !['create', 'ensure-link'].includes(action)) return `${tables[family]}:${id ?? 'missing-id'}`;
  if (['extra.stock-tracking', 'extra.ensure-resold-stock-item'].includes(type)) return `extras:${payload.extra_id}`;
  if (type === 'daily-situation.config') return 'waise_daily_situation_config:1';
  if (type === 'daily-situation.finalize') return payload.date ? `daily:${payload.date}` : 'daily:missing-date';
  if (type === 'product-suppliers.update') return `products:${payload.product_id}`;
  if (family === 'stock-setting' && ['update', 'delete'].includes(action)) {
    const table = (payload.type ?? payload.setting_type) === 'loss_type' ? 'loss_types' : (payload.type ?? payload.setting_type) === 'loss_cause' ? 'loss_causes' : null;
    if (table && id) return `${table}:${id}`;
  }
  if (type === 'stock-setting.create' && payload.type === 'item_threshold') return `stock_items:${payload.data?.stock_item_id}`;
  return null;
}
module.exports = {
  waiseRevisionResource
};
